export const analysisTime =(str)=>{
    if(!str) return str
    let arr = str.split('-')
    const numMap = ["一", "二", "三", "四"];
    let num = Number(arr[1].substr(1,1))
    return `${arr[0]}年第${numMap[num-1]}季度`
}

export const exportFile = (file,fileName) => {
    const blob = new Blob([file], {type: 'application/vnd.ms-excel;charset=UTF-8'})
        // 非IE下载
        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink)

}
/**
 * 时间格式化
 *
 * format  -- 需要返回的格式
 *  yyyy-MM-DD HH:mm:ss
 *
 * **/
Date.prototype.format = function (fmt) { //author: meizz
    let o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}